module.exports = __webpack_public_path__ + "static/media/ic_ph.f4342948.svg";